// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@sc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@sc/Overrides/Widgets/MyLists/MyListsFilter";
import { css } from "styled-components";

filterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.autocompleteGridItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        & > div {
            padding: 0;
            flex: 1;
        }
    `,
};

filterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

filterStyles.fromGridItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 12, 6, 3, 3],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
        align-items: flex-end;
    `,
};

filterStyles.fromDate = {
    ...myAccountFilterSectionStyles.fromDate,
};

filterStyles.toDate = {
    ...myAccountFilterSectionStyles.toDate,
};
